import styled from "styled-components";
import Toolbar from '@material-ui/core/Toolbar';
import { AppBar } from "@material-ui/core";
// import Logo from "Assets/Images/newlogo.png";

export const ToolbarWrapper = styled(Toolbar)`
    justify-content: flex-end;

    /* .logo {
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100%;
        height: 180px;
        width: 180px;
    } */
`
export const LinksWrapper = styled.div`
    display: flex;
`

export const AppBarWrapper = styled(AppBar)`
    &.root {
        background-color: white;
    }
`